import {SELECTED_PASSENGER_DETAILS,ORIGIN_DROPDOWN,DESTINATION_DROPDOWN,FEESERVICE_DROPDOWN,PaymentType_Dropdown} from './SelectedPassengerType'

export const selectedpassengerCredential=(props)=>
{
    return{
        type:SELECTED_PASSENGER_DETAILS,
        SelectedPassengerData:props.SelectedPassengerData
    }
}
export const selectedOriginDropdownCredential=(props)=>
{
    return{
        type:ORIGIN_DROPDOWN,
        OriginDropdown:props.OriginDropdown
    }
}
export const selectedDestinationDropdownCredential=(props)=>
{
    return{
        type:DESTINATION_DROPDOWN,
        DestinationDropdown:props.DestinationDropdown
    }
}
export const FeeServiceDropdownCredential=(props)=>
{
    return{
        type:FEESERVICE_DROPDOWN,
        FeeServiceDropdown:props.FeeServiceDropdown
    }
}

export const PaymentTypeDropdownCredential=(props)=>
{
       
    return{
        type:PaymentType_Dropdown,
        PaymentTypeDropdown:props.PaymentTypeDropdown
    }
}

